import _defineProperty from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _inherits from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _createClass from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _toConsumableArray from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.math.hypot.js";
import React from 'react';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
var GestureFlag;

(function (GestureFlag) {
  GestureFlag["OnStart"] = "start";
  GestureFlag["OnChange"] = "change";
  GestureFlag["OnEnd"] = "end";
})(GestureFlag || (GestureFlag = {}));

var noop = function noop() {};

var chainFns = function chainFns() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fns.forEach(function (fn) {
      return fn.apply(void 0, args);
    });
  };
};

var addV = function addV(v1, v2) {
  return v1.map(function (v, i) {
    return v + v2[i];
  });
};

var subV = function subV(v1, v2) {
  return v1.map(function (v, i) {
    return v - v2[i];
  });
};

var setListeners = function setListeners(add) {
  return function (el, listeners, options) {
    var action = add ? 'addEventListener' : 'removeEventListener';
    listeners.forEach(function (_ref) {
      var _ref5 = _slicedToArray(_ref, 2),
          type = _ref5[0],
          fn = _ref5[1];

      return el[action](type, fn, options);
    });
  };
};

var addListeners = setListeners(true);
var removeListeners = setListeners(false);

function getModifierKeys(event) {
  var shiftKey = event.shiftKey,
      altKey = event.altKey,
      metaKey = event.metaKey,
      ctrlKey = event.ctrlKey;
  return {
    shiftKey: shiftKey,
    altKey: altKey,
    metaKey: metaKey,
    ctrlKey: ctrlKey
  };
}

function getScrollEventData(event) {
  var _event$currentTarget = event.currentTarget,
      scrollX = _event$currentTarget.scrollX,
      scrollY = _event$currentTarget.scrollY,
      scrollLeft = _event$currentTarget.scrollLeft,
      scrollTop = _event$currentTarget.scrollTop;
  return _extends({
    values: [scrollX || scrollLeft || 0, scrollY || scrollTop || 0]
  }, getModifierKeys(event));
}

function getWheelEventData(event) {
  var deltaX = event.deltaX,
      deltaY = event.deltaY;
  return _extends({
    values: [deltaX, deltaY]
  }, getModifierKeys(event));
}

function getPointerEventData(event) {
  var touches = event.touches,
      buttons = event.buttons,
      changedTouches = event.changedTouches;
  var touchEvents = touches && touches.length > 0 ? touches : changedTouches && changedTouches.length > 0 ? changedTouches : null;

  var _ref6 = touchEvents ? touchEvents[0] : event,
      clientX = _ref6.clientX,
      clientY = _ref6.clientY;

  var down = touchEvents && touchEvents.length > 0 || buttons > 0;
  return _extends({
    values: [clientX, clientY],
    touches: touchEvents && touchEvents.length || 0,
    down: down,
    buttons: buttons
  }, getModifierKeys(event));
}

function getTwoTouchesEventData(event) {
  var touches = event.touches;
  var dx = touches[1].clientX - touches[0].clientX;
  var dy = touches[1].clientY - touches[0].clientY;
  var da = [Math.hypot(dx, dy), -(Math.atan2(dx, dy) * 180) / Math.PI];
  var origin = [(touches[1].clientX + touches[0].clientX) / 2, (touches[1].clientY + touches[0].clientY) / 2];
  return _extends({
    values: da,
    origin: origin,
    touches: 2,
    down: touches.length > 0
  }, getModifierKeys(event));
}

function calculateVelocity(diff, delta_t, len) {
  len = len || Math.hypot.apply(Math, _toConsumableArray(diff));
  return delta_t ? len / delta_t : 0;
}

function calculateVelocities(diff, delta_t) {
  return delta_t ? diff.map(function (v) {
    return v / delta_t;
  }) : Array(diff.length).fill(0);
}

function calculateDistance(delta) {
  return Math.hypot.apply(Math, _toConsumableArray(delta));
}

function calculateDirection(diff, len) {
  len = len || Math.hypot.apply(Math, _toConsumableArray(diff)) || 1;
  return diff.map(function (v) {
    return v / len;
  });
}

function calculateAllKinematics(delta, diff, delta_t) {
  var len = Math.hypot.apply(Math, _toConsumableArray(diff));
  return {
    velocities: calculateVelocities(diff, delta_t),
    velocity: calculateVelocity(diff, delta_t, len),
    distance: calculateDistance(delta),
    direction: calculateDirection(diff, len)
  };
}

function supportsGestureEvent() {
  try {
    return 'constructor' in GestureEvent;
  } catch (e) {
    return false;
  }
}

var mappedKeys = {
  drag: {
    stateKey: 'drag',
    handlerKey: 'onDrag'
  },
  pinch: {
    stateKey: 'pinch',
    handlerKey: 'onPinch'
  },
  move: {
    stateKey: 'move',
    handlerKey: 'onMove'
  },
  scroll: {
    stateKey: 'scroll',
    handlerKey: 'onScroll'
  },
  wheel: {
    stateKey: 'wheel',
    handlerKey: 'onWheel'
  },
  hover: {
    stateKey: 'move',
    handlerKey: 'onHover'
  }
};
var defaultConfig = {
  domTarget: undefined,
  event: {
    passive: true,
    capture: false
  },
  pointerEvents: false,
  window: typeof window !== 'undefined' ? window : undefined,
  transform: {
    x: function x(_x) {
      return _x;
    },
    y: function y(_y) {
      return _y;
    }
  },
  enabled: true,
  drag: true,
  pinch: true,
  scroll: true,
  wheel: true,
  hover: true,
  move: true
};
var initialCommon = {
  event: undefined,
  currentTarget: undefined,
  pointerId: undefined,
  values: [0, 0],
  velocities: [0, 0],
  delta: [0, 0],
  initial: [0, 0],
  previous: [0, 0],
  transform: undefined,
  local: [0, 0],
  lastLocal: [0, 0],
  first: false,
  last: false,
  active: false,
  time: undefined,
  cancel: noop,
  canceled: false,
  temp: undefined,
  args: undefined
};
var initialCoordinates = {
  xy: [0, 0],
  vxvy: [0, 0],
  velocity: 0,
  distance: 0,
  direction: [0, 0]
};
var initialDistanceAngle = {
  da: [0, 0],
  vdva: [0, 0],
  origin: [0, 0],
  turns: 0
};
var initialState = {
  shared: {
    hovering: false,
    scrolling: false,
    wheeling: false,
    dragging: false,
    moving: false,
    pinching: false,
    touches: 0,
    buttons: 0,
    down: false,
    shiftKey: false,
    altKey: false,
    metaKey: false,
    ctrlKey: false
  },
  move: _extends({}, initialCommon, initialCoordinates),
  drag: _extends({}, initialCommon, initialCoordinates),
  scroll: _extends({}, initialCommon, initialCoordinates),
  wheel: _extends({}, initialCommon, initialCoordinates),
  pinch: _extends({}, initialCommon, initialDistanceAngle)
};
var genericEndState = {
  first: false,
  last: true,
  active: false
};

var Recognizer = /*#__PURE__*/_createClass(function Recognizer(gestureKey, controller, args) {
  var _this2 = this;

  _classCallCheck(this, Recognizer);

  var _this = this;

  if (args === void 0) {
    args = [];
  }

  this.gestureKey = gestureKey;
  this.controller = controller;
  this.args = args;
  this.stateKey = void 0;

  this.isEnabled = function () {
    return _this2.controller.config.enabled && _this2.controller.config[_this2.gestureKey];
  };

  this.setTimeout = function (callback, ms) {
    var _window;

    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    _this.controller.timeouts[_this.stateKey] = (_window = window).setTimeout.apply(_window, [callback, ms].concat(args));
  };

  this.clearTimeout = function () {
    clearTimeout(_this2.controller.timeouts[_this2.stateKey]);
  };

  this.getState = function () {
    return _this2.controller.state[_this2.stateKey];
  };

  this.getSharedState = function () {
    return _this2.controller.state.shared;
  };

  this.pointerEventsEnabled = function () {
    return _this2.controller.config.pointerEvents;
  };

  this.getTransformConfig = function () {
    return _this2.controller.config.transform;
  };

  this.addWindowListeners = function (listeners) {
    _this2.controller.addWindowListeners(_this2.stateKey, listeners);
  };

  this.removeWindowListeners = function () {
    _this2.controller.removeWindowListeners(_this2.stateKey);
  };

  this.updateState = function (sharedState, gestureState, gestureFlag) {
    _this2.controller.updateState(sharedState, gestureState, _this2.gestureKey, gestureFlag);
  };

  this.getStartState = function (values, event) {
    var state = _this2.getState();

    var initial = initialState[_this2.stateKey];

    var transform = state.transform || event.transform || _this2.getTransformConfig();

    var lastLocal = state.local || initial.local;
    return _extends({}, initial, {
      event: event,
      values: values,
      initial: values,
      previous: values,
      local: lastLocal,
      lastLocal: lastLocal,
      first: true,
      active: true,
      transform: transform,
      time: event.timeStamp,
      args: _this2.args
    });
  };

  this.stateKey = mappedKeys[gestureKey].stateKey;
});

var CoordinatesRecognizer = /*#__PURE__*/function (_Recognizer) {
  _inherits(CoordinatesRecognizer, _Recognizer);

  var _super = _createSuper(CoordinatesRecognizer);

  function CoordinatesRecognizer() {
    var _this3;

    _classCallCheck(this, CoordinatesRecognizer);

    _this3 = _super.apply(this, arguments);

    _this3.getKinematics = function (values, event) {
      var state = _this3.getState();

      var xy = state.values,
          initial = state.initial,
          lastLocal = state.lastLocal,
          _state$time = state.time,
          time = _state$time === void 0 ? 0 : _state$time;

      var transform = state.transform || event.transform || _this3.getTransformConfig();

      var delta = subV(values, initial).map(function (v, i) {
        return Object.values(transform)[i](v);
      });
      var diff = subV(values, xy).map(function (v, i) {
        return Object.values(transform)[i](v);
      });
      var delta_t = event.timeStamp - time;

      var _calculateAllKinemati = calculateAllKinematics(delta, diff, delta_t),
          velocity = _calculateAllKinemati.velocity,
          velocities = _calculateAllKinemati.velocities,
          distance = _calculateAllKinemati.distance,
          direction = _calculateAllKinemati.direction;

      return {
        event: event,
        values: values,
        delta: delta,
        velocity: velocity,
        velocities: velocities,
        distance: distance,
        direction: direction,
        local: addV(lastLocal, delta),
        previous: xy,
        transform: transform,
        time: event.timeStamp
      };
    };

    return _this3;
  }

  return _createClass(CoordinatesRecognizer);
}(Recognizer);

var DragRecognizer = /*#__PURE__*/function (_CoordinatesRecognize) {
  _inherits(DragRecognizer, _CoordinatesRecognize);

  var _super2 = _createSuper(DragRecognizer);

  function DragRecognizer(controller, args) {
    var _this4;

    _classCallCheck(this, DragRecognizer);

    _this4 = _super2.call(this, 'drag', controller, args);

    _this4.onStart = function (event) {
      if (!_this4.isEnabled()) return;

      var _getPointerEventData = getPointerEventData(event),
          values = _getPointerEventData.values,
          rest = _objectWithoutPropertiesLoose(_getPointerEventData, ["values"]);

      if (rest.touches > 1) return;
      var currentTarget = event.currentTarget,
          pointerId = event.pointerId;

      if (_this4.pointerEventsEnabled()) {
        currentTarget && currentTarget.setPointerCapture(pointerId);
      } else {
        _this4.removeWindowListeners();

        var dragListeners = [['mousemove', _this4.onChange], ['mouseup', _this4.onEnd], ['touchmove', _this4.onChange], ['touchend', _this4.onEnd], ['touchcancel', _this4.onEnd]];

        _this4.addWindowListeners(dragListeners);
      }

      var startState = _this4.getStartState(values, event);

      _this4.updateState(_extends({}, rest, {
        dragging: true,
        down: true
      }), _extends({}, startState, {
        currentTarget: currentTarget,
        pointerId: pointerId,
        cancel: function cancel() {
          return _this4.onCancel(event);
        }
      }), GestureFlag.OnStart);
    };

    _this4.onChange = function (event) {
      var _this4$getState = _this4.getState(),
          canceled = _this4$getState.canceled,
          active = _this4$getState.active;

      if (canceled || !active) return;

      var _getPointerEventData2 = getPointerEventData(event),
          values = _getPointerEventData2.values,
          rest = _objectWithoutPropertiesLoose(_getPointerEventData2, ["values"]);

      if (rest.buttons === 0 && rest.touches === 0) {
        _this4.onEnd(event);

        return;
      }

      var kinematics = _this4.getKinematics(values, event);

      var cancel = function cancel() {
        return _this4.onCancel(event);
      };

      _this4.updateState(rest, _extends({}, kinematics, {
        first: false,
        cancel: cancel
      }), GestureFlag.OnChange);
    };

    _this4.onEnd = function (event) {
      var state = _this4.getState();

      if (!state.active) return;
      var currentTarget = state.currentTarget,
          pointerId = state.pointerId;
      if (currentTarget && _this4.pointerEventsEnabled()) currentTarget.releasePointerCapture(pointerId);else _this4.removeWindowListeners();

      _this4.updateState({
        dragging: false,
        down: false,
        buttons: 0,
        touches: 0
      }, _extends({}, genericEndState, {
        event: event
      }), GestureFlag.OnEnd);
    };

    _this4.onCancel = function (event) {
      _this4.updateState(null, {
        canceled: true,
        cancel: noop
      });

      requestAnimationFrame(function () {
        return _this4.onEnd(event);
      });
    };

    return _this4;
  }

  _createClass(DragRecognizer, [{
    key: "getEventBindings",
    value: function getEventBindings() {
      if (this.pointerEventsEnabled()) {
        return [['onPointerDown', this.onStart], ['onPointerMove', this.onChange], [['onPointerUp', 'onPointerCancel'], this.onEnd]];
      }

      return [[['onMouseDown', 'onTouchStart'], this.onStart]];
    }
  }]);

  return DragRecognizer;
}(CoordinatesRecognizer);

var ScrollRecognizer = /*#__PURE__*/function (_CoordinatesRecognize2) {
  _inherits(ScrollRecognizer, _CoordinatesRecognize2);

  var _super3 = _createSuper(ScrollRecognizer);

  function ScrollRecognizer(controller, args) {
    var _this5;

    _classCallCheck(this, ScrollRecognizer);

    _this5 = _super3.call(this, 'scroll', controller, args);

    _this5.onChange = function (event) {
      if (!_this5.isEnabled()) return;

      _this5.clearTimeout();

      _this5.setTimeout(_this5.onEnd, 100);

      var _getScrollEventData = getScrollEventData(event),
          values = _getScrollEventData.values,
          rest = _objectWithoutPropertiesLoose(_getScrollEventData, ["values"]);

      if (!_this5.getState().active) {
        var startState = _this5.getStartState(values, event);

        _this5.updateState(_extends({
          scrolling: true
        }, rest), startState, GestureFlag.OnStart);
      } else {
        var kinematics = _this5.getKinematics(values, event);

        _this5.updateState(rest, _extends({}, kinematics, {
          first: false
        }), GestureFlag.OnChange);
      }
    };

    _this5.onEnd = function () {
      if (!_this5.getState().active) return;

      _this5.updateState({
        scrolling: false
      }, _extends({}, genericEndState, {
        velocity: 0,
        velocities: [0, 0]
      }), GestureFlag.OnEnd);
    };

    return _this5;
  }

  _createClass(ScrollRecognizer, [{
    key: "getEventBindings",
    value: function getEventBindings() {
      return [['onScroll', this.onChange]];
    }
  }]);

  return ScrollRecognizer;
}(CoordinatesRecognizer);

var WheelRecognizer = /*#__PURE__*/function (_CoordinatesRecognize3) {
  _inherits(WheelRecognizer, _CoordinatesRecognize3);

  var _super4 = _createSuper(WheelRecognizer);

  function WheelRecognizer(controller, args) {
    var _this6;

    _classCallCheck(this, WheelRecognizer);

    _this6 = _super4.call(this, 'wheel', controller, args);

    _this6.onChange = function (event) {
      if (!_this6.isEnabled()) return;

      _this6.clearTimeout();

      _this6.setTimeout(_this6.onEnd, 100);

      var _getWheelEventData = getWheelEventData(event),
          eventValues = _getWheelEventData.values,
          rest = _objectWithoutPropertiesLoose(_getWheelEventData, ["values"]);

      var values = addV(eventValues, _this6.getState().values);

      if (!_this6.getState().active) {
        var startState = _this6.getStartState(values, event);

        _this6.updateState(_extends({
          wheeling: true
        }, rest), startState, GestureFlag.OnStart);
      } else {
        var kinematics = _this6.getKinematics(values, event);

        _this6.updateState(rest, _extends({}, kinematics, {
          first: false
        }), GestureFlag.OnChange);
      }
    };

    _this6.onEnd = function () {
      if (!_this6.getState().active) return;

      _this6.updateState({
        wheeling: false
      }, _extends({}, genericEndState, {
        velocity: 0,
        velocities: [0, 0]
      }), GestureFlag.OnEnd);
    };

    return _this6;
  }

  _createClass(WheelRecognizer, [{
    key: "getEventBindings",
    value: function getEventBindings() {
      return [['onWheel', this.onChange]];
    }
  }]);

  return WheelRecognizer;
}(CoordinatesRecognizer);

var MoveRecognizer = /*#__PURE__*/function (_CoordinatesRecognize4) {
  _inherits(MoveRecognizer, _CoordinatesRecognize4);

  var _super5 = _createSuper(MoveRecognizer);

  function MoveRecognizer(controller, args) {
    var _this7;

    _classCallCheck(this, MoveRecognizer);

    _this7 = _super5.call(this, 'move', controller, args);

    _this7.onChange = function (event) {
      if (!_this7.isEnabled()) return;

      _this7.clearTimeout();

      _this7.setTimeout(_this7.onEnd, 100);

      var _getPointerEventData = getPointerEventData(event),
          values = _getPointerEventData.values,
          rest = _objectWithoutPropertiesLoose(_getPointerEventData, ["values"]);

      if (!_this7.getState().active) {
        var startState = _this7.getStartState(values, event);

        _this7.updateState(_extends({
          moving: true
        }, rest), startState, GestureFlag.OnStart);
      } else {
        var kinematics = _this7.getKinematics(values, event);

        _this7.updateState(rest, _extends({}, kinematics, {
          first: false
        }), GestureFlag.OnChange);
      }
    };

    _this7.onEnd = function () {
      if (!_this7.getState().active) return;

      _this7.updateState({
        moving: false
      }, _extends({}, genericEndState, {
        velocity: 0,
        velocities: [0, 0]
      }), GestureFlag.OnEnd);
    };

    return _this7;
  }

  _createClass(MoveRecognizer, [{
    key: "getEventBindings",
    value: function getEventBindings() {
      if (this.pointerEventsEnabled()) {
        return [['onPointerMove', this.onChange]];
      }

      return [['onMouseMove', this.onChange]];
    }
  }]);

  return MoveRecognizer;
}(CoordinatesRecognizer);

var HoverRecognizer = /*#__PURE__*/function (_CoordinatesRecognize5) {
  _inherits(HoverRecognizer, _CoordinatesRecognize5);

  var _super6 = _createSuper(HoverRecognizer);

  function HoverRecognizer(controller, args) {
    var _this8;

    _classCallCheck(this, HoverRecognizer);

    _this8 = _super6.call(this, 'hover', controller, args);

    _this8.onStart = function (event) {
      if (!_this8.isEnabled()) return;

      var _getPointerEventData = getPointerEventData(event),
          values = _getPointerEventData.values,
          rest = _objectWithoutPropertiesLoose(_getPointerEventData, ["values"]);

      _this8.updateState(_extends({
        hovering: true
      }, rest), {
        values: values,
        event: event,
        args: _this8.args
      }, GestureFlag.OnChange);
    };

    _this8.onEnd = function (event) {
      if (!_this8.isEnabled()) return;

      var _getPointerEventData2 = getPointerEventData(event),
          values = _getPointerEventData2.values,
          rest = _objectWithoutPropertiesLoose(_getPointerEventData2, ["values"]);

      var kinematics = _this8.getKinematics(values, event);

      _this8.updateState(_extends({
        hovering: false,
        moving: false
      }, rest), _extends({}, kinematics, genericEndState, {
        velocity: 0,
        velocities: [0, 0]
      }));

      _this8.controller.fireGestureHandler('move', GestureFlag.OnEnd);

      _this8.controller.fireGestureHandler('hover', GestureFlag.OnChange);
    };

    return _this8;
  }

  _createClass(HoverRecognizer, [{
    key: "getEventBindings",
    value: function getEventBindings() {
      if (this.pointerEventsEnabled()) {
        return [['onPointerEnter', this.onStart], ['onPointerLeave', this.onEnd]];
      }

      return [['onMouseEnter', this.onStart], ['onMouseLeave', this.onEnd]];
    }
  }]);

  return HoverRecognizer;
}(CoordinatesRecognizer);

var DistanceAngleRecognizer = /*#__PURE__*/function (_Recognizer2) {
  _inherits(DistanceAngleRecognizer, _Recognizer2);

  var _super7 = _createSuper(DistanceAngleRecognizer);

  function DistanceAngleRecognizer() {
    var _this9;

    _classCallCheck(this, DistanceAngleRecognizer);

    _this9 = _super7.apply(this, arguments);

    _this9.getKinematics = function (_ref, event) {
      var _ref7 = _slicedToArray(_ref, 2),
          d = _ref7[0],
          a = _ref7[1];

      var state = _this9.getState();

      var da = state.values,
          turns = state.turns,
          initial = state.initial,
          lastLocal = state.lastLocal,
          _state$time2 = state.time,
          time = _state$time2 === void 0 ? 0 : _state$time2;
      a = a === undefined ? da[1] : a;
      var diff_d = d - da[0];
      var diff_a = a - da[1];
      var newTurns = Math.abs(diff_a) > 300 ? turns + Math.sign(diff_a) : turns;
      diff_a -= 360 * newTurns;
      var delta_d = d - initial[0];
      var delta_a = a - 360 * newTurns - initial[1];
      var delta = [delta_d, delta_a];
      var delta_t = event.timeStamp - time;
      var velocities = calculateVelocities([diff_d, diff_a], delta_t);
      return {
        event: event,
        values: [d, a],
        delta: delta,
        velocities: velocities,
        turns: newTurns,
        local: addV(lastLocal, delta),
        previous: da,
        time: event.timeStamp
      };
    };

    return _this9;
  }

  return _createClass(DistanceAngleRecognizer);
}(Recognizer);

var PinchRecognizer = /*#__PURE__*/function (_DistanceAngleRecogni) {
  _inherits(PinchRecognizer, _DistanceAngleRecogni);

  var _super8 = _createSuper(PinchRecognizer);

  function PinchRecognizer(controller, args) {
    var _this10;

    _classCallCheck(this, PinchRecognizer);

    _this10 = _super8.call(this, 'pinch', controller, args);

    _this10.onStart = function (event) {
      if (!_this10.isEnabled() || event.touches.length !== 2) return;

      var _getTwoTouchesEventDa = getTwoTouchesEventData(event),
          values = _getTwoTouchesEventDa.values,
          origin = _getTwoTouchesEventDa.origin,
          rest = _objectWithoutPropertiesLoose(_getTwoTouchesEventDa, ["values", "origin"]);

      var startState = _this10.getStartState(values, event);

      _this10.updateState(_extends({}, rest, {
        pinching: true,
        down: true
      }), _extends({}, startState, {
        origin: origin,
        cancel: function cancel() {
          return _this10.onCancel(event);
        }
      }), GestureFlag.OnStart);
    };

    _this10.onChange = function (event) {
      var _this10$getState = _this10.getState(),
          canceled = _this10$getState.canceled,
          active = _this10$getState.active;

      if (canceled || !active || event.touches.length !== 2) return;

      var _getTwoTouchesEventDa2 = getTwoTouchesEventData(event),
          values = _getTwoTouchesEventDa2.values,
          origin = _getTwoTouchesEventDa2.origin,
          rest = _objectWithoutPropertiesLoose(_getTwoTouchesEventDa2, ["values", "origin"]);

      var kinematics = _this10.getKinematics(values, event);

      var cancel = function cancel() {
        return _this10.onCancel(event);
      };

      _this10.updateState(rest, _extends({}, kinematics, {
        origin: origin,
        first: false,
        cancel: cancel
      }), GestureFlag.OnChange);
    };

    _this10.onEnd = function (event) {
      if (!_this10.getState().active) return;

      _this10.updateState({
        pinching: false,
        down: false,
        touches: 0
      }, _extends({}, genericEndState, {
        event: event
      }), GestureFlag.OnEnd);
    };

    _this10.onCancel = function (event) {
      _this10.updateState(null, {
        canceled: true,
        cancel: noop
      });

      requestAnimationFrame(function () {
        return _this10.onEnd(event);
      });
    };

    return _this10;
  }

  _createClass(PinchRecognizer, [{
    key: "getEventBindings",
    value: function getEventBindings() {
      return [['onTouchStart', this.onStart], ['onTouchMove', this.onChange], [['onTouchEnd', 'onTouchCancel'], this.onEnd]];
    }
  }]);

  return PinchRecognizer;
}(DistanceAngleRecognizer);

var PinchWheelRecognizer = /*#__PURE__*/function (_DistanceAngleRecogni2) {
  _inherits(PinchWheelRecognizer, _DistanceAngleRecogni2);

  var _super9 = _createSuper(PinchWheelRecognizer);

  function PinchWheelRecognizer(controller, args) {
    var _this11;

    _classCallCheck(this, PinchWheelRecognizer);

    _this11 = _super9.call(this, 'pinch', controller, args);

    _this11.onChange = function (event) {
      if (!_this11.isEnabled() || !event.ctrlKey) return;
      event.preventDefault();

      _this11.clearTimeout();

      _this11.setTimeout(_this11.onEnd, 100);

      var _getWheelEventData = getWheelEventData(event),
          values = _getWheelEventData.values,
          rest = _objectWithoutPropertiesLoose(_getWheelEventData, ["values"]);

      var d = _this11.getState().values[0] - values[1];

      if (!_this11.getState().active) {
        var startState = _this11.getStartState([d, 0], event);

        _this11.updateState(_extends({
          pinching: true
        }, rest), startState, GestureFlag.OnStart);
      } else {
        var kinematics = _this11.getKinematics([d, undefined], event);

        _this11.updateState(rest, _extends({}, kinematics, {
          first: false
        }), GestureFlag.OnChange);
      }
    };

    _this11.onEnd = function () {
      if (!_this11.getState().active) return;

      _this11.updateState({
        pinching: false,
        down: false,
        touches: 0
      }, _extends({}, genericEndState), GestureFlag.OnEnd);
    };

    return _this11;
  }

  _createClass(PinchWheelRecognizer, [{
    key: "getEventBindings",
    value: function getEventBindings() {
      return [['onWheel', this.onChange]];
    }
  }]);

  return PinchWheelRecognizer;
}(DistanceAngleRecognizer);

var SCALE_FACTOR = 260;

var PinchWebKitGestureRecognizer = /*#__PURE__*/function (_DistanceAngleRecogni3) {
  _inherits(PinchWebKitGestureRecognizer, _DistanceAngleRecogni3);

  var _super10 = _createSuper(PinchWebKitGestureRecognizer);

  function PinchWebKitGestureRecognizer(controller, args) {
    var _this12;

    _classCallCheck(this, PinchWebKitGestureRecognizer);

    _this12 = _super10.call(this, 'pinch', controller, args);

    _this12.onStart = function (event) {
      if (!_this12.isEnabled()) return;
      event.preventDefault();
      var da = [event.scale * SCALE_FACTOR, event.rotation];

      var startState = _this12.getStartState(da, event);

      _this12.updateState({
        pinching: true,
        down: true,
        touches: 2
      }, _extends({}, startState, {
        cancel: function cancel() {
          return _this12.onCancel(event);
        }
      }), GestureFlag.OnStart);
    };

    _this12.onChange = function (event) {
      var _this12$getState = _this12.getState(),
          canceled = _this12$getState.canceled,
          active = _this12$getState.active;

      if (canceled || !active) return;
      event.preventDefault();
      var da = [event.scale * SCALE_FACTOR, event.rotation];

      var kinematics = _this12.getKinematics(da, event);

      var cancel = function cancel() {
        return _this12.onCancel(event);
      };

      _this12.updateState(null, _extends({}, kinematics, {
        first: false,
        cancel: cancel
      }), GestureFlag.OnChange);
    };

    _this12.onEnd = function (event) {
      if (!_this12.getState().active) return;
      event.preventDefault();

      _this12.updateState({
        pinching: false,
        down: false,
        touches: 0
      }, _extends({}, genericEndState, {
        event: event
      }), GestureFlag.OnEnd);
    };

    _this12.onCancel = function (event) {
      _this12.updateState(null, {
        canceled: true,
        cancel: noop
      });

      requestAnimationFrame(function () {
        return _this12.onEnd(event);
      });
    };

    _this12.updateTouchData = function (event) {
      var _getTwoTouchesEventDa3 = getTwoTouchesEventData(event),
          origin = _getTwoTouchesEventDa3.origin;

      _this12.updateState(null, {
        origin: origin
      });
    };

    return _this12;
  }

  _createClass(PinchWebKitGestureRecognizer, [{
    key: "getEventBindings",
    value: function getEventBindings() {
      return [['onGestureStart', this.onStart], ['onGestureChange', this.onChange], [['onGestureEnd', 'onTouchCancel'], this.onEnd], [['onTouchStart', 'onTouchMove'], this.updateTouchData]];
    }
  }]);

  return PinchWebKitGestureRecognizer;
}(DistanceAngleRecognizer);

var GestureController = /*#__PURE__*/_createClass(function GestureController(_handlers, _config) {
  var _this13 = this;

  _classCallCheck(this, GestureController);

  var _this = this;

  this.handlers = void 0;
  this.config = void 0;
  this.state = initialState;
  this.timeouts = {};
  this.bindings = {};
  this.domListeners = [];
  this.windowListeners = {};

  this.setHandlersAndConfig = function (handlers, config) {
    if (typeof handlers === 'function') handlers = {
      onDrag: handlers
    };else if (handlers.onAction) {
      handlers.onDrag = handlers.onAction;
      delete handlers.onAction;
    }
    _this13.config = _extends({}, defaultConfig, config);
    var domTarget = _this13.config.domTarget;
    var realDomTarget = domTarget && 'current' in domTarget ? domTarget.current : domTarget;
    _this13.config.domTarget = realDomTarget;
    _this13.handlers = handlers;
  };

  this.clean = function () {
    _this13.cleanOnBind();

    Object.values(_this13.timeouts).forEach(clearTimeout);
    Object.keys(_this13.windowListeners).forEach(function (stateKey) {
      return _this13.removeWindowListeners(stateKey);
    });
  };

  this.cleanOnBind = function () {
    _this13.bindings = {};
    var domTarget = _this13.config.domTarget;

    if (domTarget) {
      removeListeners(domTarget, _this13.domListeners, _this13.config.event);
      _this13.domListeners = [];
    }
  };

  this.updateState = function (sharedState, gestureState, gestureKey, gestureFlag) {
    var stateKey = mappedKeys[gestureKey].stateKey;
    _this13.state = _extends({}, _this13.state, _defineProperty({
      shared: _extends({}, _this13.state.shared, sharedState)
    }, stateKey, _extends({}, _this13.state[stateKey], gestureState)));

    if (gestureFlag) {
      _this13.fireGestureHandler(gestureKey, gestureFlag);
    }
  };

  this.fireGestureHandler = function (gestureKey, gestureFlag) {
    var _mappedKeys$gestureKe = mappedKeys[gestureKey],
        stateKey = _mappedKeys$gestureKe.stateKey,
        handlerKey = _mappedKeys$gestureKe.handlerKey;

    var state = _extends({}, _this13.state.shared, _this13.state[stateKey]);

    if (gestureKey === 'pinch') {
      var pinchState = state;
      pinchState.da = state.values;
      pinchState.vdva = state.velocities;
    } else {
      var coordinatesState = state;
      coordinatesState.xy = state.values;
      coordinatesState.vxvy = state.velocities;
    }

    if (gestureFlag === GestureFlag.OnStart) {
      var handlerStart = handlerKey + "Start";
      var _handler = _this13.handlers[handlerStart];
      _handler && _handler(state);
    }

    var handler = _this13.handlers[handlerKey];

    if (handler) {
      _this13.state[stateKey].temp = handler(state) || _this13.state[stateKey].temp;
    }

    if (gestureFlag === GestureFlag.OnEnd) {
      var handlerEnd = handlerKey + "End";
      var _handler2 = _this13.handlers[handlerEnd];
      _handler2 && _handler2(state);
    }
  };

  this.addWindowListeners = function (stateKey, listeners) {
    if (!_this13.config.window) return;
    _this13.windowListeners[stateKey] = listeners;
    addListeners(_this13.config.window, listeners, _this13.config.event);
  };

  this.removeWindowListeners = function (stateKey) {
    if (!_this13.config.window) return;
    var listeners = _this13.windowListeners[stateKey];

    if (listeners) {
      removeListeners(_this13.config.window, listeners, _this13.config.event);
      delete _this13.windowListeners[stateKey];
    }
  };

  this.addRecognizer = function (recognizer) {
    recognizer.getEventBindings().map(_this13.addEventBindings);
  };

  this.addEventBindings = function (_ref) {
    var _ref8 = _slicedToArray(_ref, 2),
        eventNames = _ref8[0],
        fn = _ref8[1];

    var eventNamesArray = !Array.isArray(eventNames) ? [eventNames] : eventNames;
    eventNamesArray.forEach(function (eventName) {
      _this13.bindings[eventName] = _this13.bindings[eventName] ? [].concat(_toConsumableArray(_this13.bindings[eventName]), [fn]) : [fn];
    });
  };

  this.addDomTargetListeners = function () {
    var domTarget = _this13.config.domTarget;
    Object.entries(_this13.bindings).forEach(function (_ref2) {
      var _ref9 = _slicedToArray(_ref2, 2),
          event = _ref9[0],
          fns = _ref9[1];

      _this13.domListeners.push([event.substr(2).toLowerCase(), chainFns.apply(void 0, _toConsumableArray(fns))]);
    });
    addListeners(domTarget, _this13.domListeners, _this13.config.event);
  };

  this.getBindings = function () {
    var output = {};
    var captureString = _this13.config.event.capture ? 'Capture' : '';
    Object.entries(_this13.bindings).forEach(function (_ref3) {
      var _ref10 = _slicedToArray(_ref3, 2),
          event = _ref10[0],
          fns = _ref10[1];

      var fnsArray = Array.isArray(fns) ? fns : [fns];
      var key = event + captureString;
      output[key] = chainFns.apply(void 0, _toConsumableArray(fnsArray));
    });
    return output;
  };

  this.bind = function () {
    var actions = new Set(Object.keys(_this.handlers).filter(function (k) {
      return k.indexOf('on') === 0;
    }).map(function (k) {
      var match = k.match(/(on[A-Z][a-z]+)/);
      if (match) return match[1];
    }));
    var domTarget = _this.config.domTarget;

    var genuineHandlers = _extends({}, _this.handlers);

    _this.cleanOnBind();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (actions.has('onDrag')) {
      _this.addRecognizer(new DragRecognizer(_this, args));

      delete genuineHandlers.onDrag;
      delete genuineHandlers.onDragStart;
      delete genuineHandlers.onDragEnd;
    }

    if (actions.has('onScroll')) {
      _this.addRecognizer(new ScrollRecognizer(_this, args));

      delete genuineHandlers.onScroll;
      delete genuineHandlers.onScrollStart;
      delete genuineHandlers.onScrollEnd;
    }

    if (actions.has('onWheel')) {
      _this.addRecognizer(new WheelRecognizer(_this, args));

      delete genuineHandlers.onWheel;
      delete genuineHandlers.onWheelStart;
      delete genuineHandlers.onWheelEnd;
    }

    if (actions.has('onMove')) {
      _this.addRecognizer(new MoveRecognizer(_this, args));

      delete genuineHandlers.onMove;
      delete genuineHandlers.onMoveStart;
      delete genuineHandlers.onMoveEnd;
    }

    if (actions.has('onHover')) {
      _this.addRecognizer(new HoverRecognizer(_this, args));

      delete genuineHandlers.onHover;
    }

    if (actions.has('onPinch')) {
      if (domTarget && supportsGestureEvent()) {
        _this.addRecognizer(new PinchWebKitGestureRecognizer(_this, args));
      } else {
        _this.addRecognizer(new PinchRecognizer(_this, args));

        _this.addRecognizer(new PinchWheelRecognizer(_this, args));
      }

      delete genuineHandlers.onPinch;
      delete genuineHandlers.onPinchStart;
      delete genuineHandlers.onPinchEnd;
    }

    Object.entries(genuineHandlers).map(function (_ref4) {
      var _ref11 = _slicedToArray(_ref4, 2),
          event = _ref11[0],
          fn = _ref11[1];

      _this.addEventBindings([event, fn]);
    });

    if (domTarget) {
      _this.addDomTargetListeners();

      return _this.clean;
    }

    return _this.getBindings();
  };

  this.setHandlersAndConfig(_handlers, _config);
});

function useGesture(handlers, config) {
  var gestureController = React.useRef();

  if (!gestureController.current) {
    gestureController.current = new GestureController(handlers, config);
  }

  React.useEffect(function () {
    gestureController.current.setHandlersAndConfig(handlers, config);
  }, [handlers, config]);
  React.useEffect(function () {
    return gestureController.current.clean;
  }, []);
  return gestureController.current.bind;
}

export { useGesture };